export const availableConfigValues = (["ai.workflows.tenants.config.footer", "ai.workflows.tenants.config.gateway", "ai.workflows.tenants.config.landing", "ai.workflows.tenants.config.legalAgreements", "ai.workflows.tenants.config.signup", "ai.workflows.tenants.config.signupCallout", "ai.workflows.tenants.config.languages", "ai.workflows.tenants.config.taskInbox", "ai.workflows.tenants.config.privacyStatement", "ai.workflows.tenants.config.publicPortal"] as const);
export const globalConfigValues = ((availableConfigValues as unknown) as string[]);
export type ConfigValueKey = (typeof availableConfigValues)[number];
export enum TenantRoles {
  User = "tenant.user",
  Guest = "tenant.guest",
  Admin = "tenant.admin",
}
export enum Roles {
  Owner = "ai.workflows.roles.role:owner",
}
export enum VertragsgeneratorRoles {
  Assignee = "de.smartconex.vertragsgenerator.assignee",
}